"use client";
import {
  createStoreContext
} from "./3ORBWXWF.js";

// src/disclosure/disclosure-context.tsx
var ctx = createStoreContext();
var useDisclosureContext = ctx.useContext;
var useDisclosureScopedContext = ctx.useScopedContext;
var useDisclosureProviderContext = ctx.useProviderContext;
var DisclosureContextProvider = ctx.ContextProvider;
var DisclosureScopedContextProvider = ctx.ScopedContextProvider;

export {
  useDisclosureContext,
  useDisclosureScopedContext,
  useDisclosureProviderContext,
  DisclosureContextProvider,
  DisclosureScopedContextProvider
};
